<template>
  <lateral-modal
    :title="$t(modalHeaderLabel)"
    @close="closeModal"
  >
    <template slot="content">
      <form
        id="funnel-aproval-flow-form"
        @submit.prevent="submitReviewFlow"
      >
        <div class="row">
          <div class="col-12">
            <div class="input--block input--block--margin">
              <label
                for=""
                class="form--label u-required"
              >
                {{$t('company_create_funnel_flow_modal_form_name').toUpperCase()}}
              </label>
              <div
                class="Form-field"
                :class="{ 'Form--field-error': $v.reviewFlow.name.$error}"
              >
                <input
                  type="text"
                  v-model="reviewFlow.name"
                  :placeholder="$t('company_create_funnel_flow_modal_form_name_placeholder')"
                  class="Input-text"
                  @blur="$v.reviewFlow.name.$touch()"
                >

              </div>

            </div>
          </div>
          <div class="col-12 mt-3">
            <span class="section-header">{{$t('company_create_funnel_flow_modal_form_include_flow_in')}}</span>
            <div class="">
              <label
                for=""
                class="form--label u-required"
              >{{$t('company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name').toUpperCase()}}</label>
              <div
                class="multiselect-tag-container"
                :class="{'multiselect--error' : $v.reviewFlow.flowBudgets.$error}"
              >
                <multiselect
                  :options="budgets"
                  id="include-in-selected-budgets"
                  :track-by="'id'"
                  :customLabel="(option) => option.budget.name"
                  allowEmpty
                  :placeholder="$t('company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name_placeholder')"
                  :value="reviewFlow.flowBudgets"
                  multiple
                  @select="checkBudgets($event)"
                  @remove="removeBudget($event)"
                  :selectLabel="''"
                  :deselectLabel="''"
                  :selectedLabel="'Selected'"
                  @close="$v.reviewFlow.flowBudgets.$touch()"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                  <template v-slot:noOptions>
                    <span>{{$t('multiselect_no_options_slot_default')}}</span>
                  </template>
                  <template v-slot:noResult>
                    <span>{{$t('MULTISELECT_DEFAULT_NO_RESULTS')}}</span>
                  </template>

                </multiselect>
              </div>
              <input-checkbox
                :containerClass="'d-flex justify-content-start align-items-center mt-2'"
                :id="'mark-as-default-review-flow'"
                :value.sync="reviewFlow.byDefault"
                @click="checkFlowByDefault($event)"
              >
                <template v-slot:input-label>
                  <span class="Fuell-Text Fuell-Text--small ml-2">{{$t('company_create_funnel_flow_modal_form_mark_as_default_label')}} <info-display :class="'icon-info'" :infoText="$t('company_create_funnel_flow_modal_form_mark_as_default_info_tooltip')" /></span>
                </template>
              </input-checkbox>

            </div>
          </div>
          <div class="col-12 mt-3">
            <span class="section-header">{{$t('company_create_funnel_flow_modal_form_flow_steps')}}</span>
            <p class="Fuell-Text">{{$t('company_create_funnel_flow_modal_form_flow_steps_hint')}}</p>
          </div>
          <div class="col-12">
            <div v-if="reviewFlow.steps.length > 0">
              <draggable
                v-model="reviewFlow.steps"
                draggable=".Fuell-Dragabble--column"
                :disabled="reviewFunnelId > 0"
              >

                <div
                  v-for="(step,index) in reviewFlow.steps"
                  :key="index"
                  class="Fuell-Dragabble--column"
                >

                  <div class="d-flex flex-column Fuell-Dragabble--column--center">
                    <div class="Fuell-Draggable--icon">
                      <img
                        :src="require('@/assets/img/icons/icon-draggable.svg')"
                        alt=""
                      >
                      {{index +1 }}
                    </div>
                  </div>
                  <div class="Fuell-Dragabble--column-content left d-flex flex-column">
                    <label
                      for=""
                      class="form--label pl-2 u-required"
                    >{{$t('company_create_funnel_flow_modal_form_flow_steps_add_step_name').toUpperCase()}}</label>
                    <input
                      type="text"
                      name=""
                      id=""
                      class="Input-text input-step"
                      :class="{'input-step--error' : $v.reviewFlow.steps.$each[index].name.$error}"
                      v-model="step.name"
                      :placeholder="$t('company_create_funnel_flow_modal_form_flow_steps_add_step_name_placeholder')"
                      @blur="$v.reviewFlow.steps.$each[index].name.$touch()"
                    >
                  </div>
                  <div class="Fuell-Dragabble--column-content right d-flex flex-column">
                    <label
                      for=""
                      class="form--label pl-2 u-required"
                    >{{$t('company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers').toUpperCase()}}</label>
                    <div
                      class="multiselect-tag-container multiselect-tags"
                      :class="{'multiselect--error' : $v.reviewFlow.steps.$each[index].reviewers.$error }"
                    >
                      <multiselect
                        id="'step-reviewers-selector'"
                        track-by="id"
                        :customLabel="(option) => `${option.firstName} ${option.lastName}`"
                        v-model="step.reviewers"
                        :options="reviewersOptions"
                        multiple
                        :searchable="true"
                        :maxHeight="200"
                        :placeholder="$t('company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers_placeholder')"
                        :selectLabel="''"
                        :deselectLabel="''"
                        :selectedLabel="''"
                        @remove="removeReviewer($event, step)"
                        @close="$v.reviewFlow.steps.$each[index].reviewers.$touch()"
                      >
                        <div
                          class="caret"
                          slot="caret"
                          slot-scope="{ toggle }"
                          @mousedown.prevent.stop="toggle"
                        >
                          <i
                            class="Ctrl Ctrl--16"
                            aria-hidden="true"
                          >
                            <svg
                              focusable="false"
                              aria-hidden="true"
                              aria-label="Edit"
                            >
                              <use xlink:href="#dropdown-icon"></use>
                            </svg>
                          </i>
                        </div>
                        <template
                          slot="option"
                          slot-scope="{ option }"
                        >
                          <div v-if="option.code !== 'ROLE_BUDGET_OWNER'">
                            {{option.firstName + ' '+option.lastName}}
                          </div>
                          <div
                            class="position-relative"
                            v-else
                          >
                            {{option.firstName + ' ' + option.lastName}}
                            <span class="role-delimiter"></span>
                          </div>
                        </template>
                        <template v-slot:noOptions>
                          <span>{{$t('multiselect_no_options_slot_default')}}</span>
                        </template>
                        <template v-slot:noResult>
                          <span>{{$t('MULTISELECT_DEFAULT_NO_RESULTS')}}</span>
                        </template>

                      </multiselect>
                    </div>
                  </div>
                  <div class="d-flex flex-column Fuell-Dragabble--column--center">
                    <div
                      class="close-container clickable"
                      v-if="!reviewFunnelId"
                      @click="removeStep(index)"
                    >
                      <img
                        class="icon-close"
                        alt="icon-close"
                        :src="require('@/assets/img/icons/close-menu.svg')"
                      />
                    </div>
                  </div>

                </div>
              </draggable>
            </div>

            <button
              class="Fuell-Button green--undo w-100"
              v-if="!reviewFunnelId"
              @click.prevent="addFlowStep"
            > {{$t('company_create_funnel_flow_modal_form_flow_steps_add_step')}}</button>
          </div>
        </div>
      </form>
    </template>
    <template slot="footer">
      <button
        type="submit"
        :disabled="$v.$invalid"
        form="funnel-aproval-flow-form"
        class="Fuell-Button blue w-100"
      >
        {{submitButtonLabel}}
      </button>
    </template>
    <template slot="modals">
      <confirm-modal
        :id="'budget-reassignation-confirm-modal'"
        :open.sync="showConfirmBudgetReassignModalFlag"
        v-if="showConfirmBudgetReassignModalFlag"
        :title="'company_create_funnel_flow_modal_form_confirm_budget_change_header'"
        :message="'company_create_funnel_flow_modal_form_confirm_budget_change_warning'"
        @accept="addBudget"
        :acceptText="'company_create_funnel_flow_modal_form_confirm_budget_change_action_confirm'"
        :dismissText="'ACTION_CANCEL'"
        :acceptBtnClass="'blue'"
        :dismissBtnClass="'Button--cancel'"
      >
      </confirm-modal>

      <confirm-modal
        :id="'default-flow-change-confirm-modal'"
        :open.sync="showConfirmDefaultFlowChangeModalFlag"
        v-if="showConfirmDefaultFlowChangeModalFlag"
        :title="'company_create_funnel_flow_modal_form_confirm_default_flow_change_header'"
        :message="'company_create_funnel_flow_modal_form_confirm_default_flow_warning'"
        @accept="confirmReviewFlowByDefault"
        @dismiss="reviewFlow.byDefault = false"
        :acceptText="'ACTION_CONFIRM'"
        :dismissText="'ACTION_CANCEL'"
        :acceptBtnClass="'blue'"
        :dismissBtnClass="'Button--cancel'"
      >
      </confirm-modal>
    </template>
  </lateral-modal>
</template>

<script>

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import InputCheckbox from '@/components/Commons/Forms/InputCheckbox'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import LateralModal from '@/components/Commons/Modals/LateralModal'

import { USER_ROLES } from '@/modules/users/_constants/userTypes'

import { mapGetters } from 'vuex'
import InfoDisplay from '../../../../../components/Commons/InfoDisplay'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const { validationMixin } = require('vuelidate')
const { required, minLength } = require('vuelidate/lib/validators')
export default {
  name: 'CreateFunnelAprovalFlowModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: { InputCheckbox, Multiselect, draggable, ConfirmModal, LateralModal, InfoDisplay },

  props: {
    reviewFunnelId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      reviewFlow: {
        name: '',
        flowBudgets: [],
        steps: [],
        byDefault: false
      },
      baseStep: {
        name: '',
        reviewers: []
      },
      budgetToConfirm: {},
      byDefaultValueToConfirm: false,
      showConfirmBudgetReassignModalFlag: false,
      showConfirmDefaultFlowChangeModalFlag: false
    }
  },
  computed: {
    modalHeaderLabel () {
      return this.reviewFunnelId ? this.$i18n.t('company_edit_funnel_flow_modal_header') : this.$i18n.t('company_create_funnel_flow_modal_header')
    },
    submitButtonLabel () {
      return this.reviewFunnelId ? this.$i18n.t('company_create_funnel_flow_modal_form_edit_flow') : this.$i18n.t('company_create_funnel_flow_modal_form_create_flow')
    },
    budgets () {
      const fakeBudgetOptionAll = {
        id: 'all',
        budget: { name: this.$i18n.t('company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_all_budgets_option'), id: 'all-budgets' },
        code: 'ALL_BUDGETS'
      }
      return [fakeBudgetOptionAll, ...this.$store.getters['BudgetsStore/budgets'].map(el => {
        return {
          id: el.id,
          budget: { name: el.name, id: el.id, flow: el.flow }
        }
      })] || []
    },

    users () {
      return this.$store.getters['UsersStore/users'] || []
    },
    reviewersOptions () {
      let fakeAdminUser = {
        id: 'admin',
        firstName: this.$i18n.t('ROLE_ADMIN'),
        lastName: '',
        code: USER_ROLES.ROLE_ADMIN
      }
      let fakeBookkeeperUser = {
        id: 'book',
        firstName: this.$i18n.t('ROLE_BOOKKEEPER'),
        lastName: '',
        code: USER_ROLES.ROLE_BOOKKEEPER
      }
      let fakeBudgetOwnerUser = {
        id: 'owner',
        firstName: this.$i18n.t('ROLE_BUDGET_OWNER'),
        lastName: '',
        code: USER_ROLES.FAKE_ROLE_BUDGET_OWNER
      }
      return [fakeAdminUser, fakeBookkeeperUser, fakeBudgetOwnerUser, ...this.users]
    },
    currentReviewFunnel () {
      return this.getReviewFlow(this.reviewFunnelId) || false
    },
    ...mapGetters('CompanyStore/TransactionFieldsStore', [
      'getReviewFlow',
      'reviewFlows'
    ]),
    hasDefaultReviewFlow () {
      return this.reviewFlows.some(el => el.byDefault)
    }

  },
  methods: {
    setIncludeIn (event) {
      this.reviewFlow.includeIn = event
    },

    removeBudget (event) {
      this.reviewFlow.flowBudgets = this.reviewFlow.flowBudgets.filter(el => el.id !== event.id)
    },
    removeReviewer (event, step) {
      step.reviewers = step.reviewers.filter(el => el.id === event.id)
    },
    setReviewFlowByDefault (event) {
      this.reviewFlow.byDefault = event
    },
    generateBudgetLabel (option) {
      return this.reviewFunnelId ? option.budget.name : option.name
    },
    checkFlowByDefault (event) {
      // if (this.hasDefaultReviewFlow && event) {
      //   this.byDefaultValueToConfirm = event
      //   this.showConfirmDefaultFlowChangeModalFlag = true
      // } else {

      this.setReviewFlowByDefault(event)
      // }
    },
    confirmReviewFlowByDefault () {
      this.reviewFlow.byDefault = true
    },
    checkBudgets (event) {
      if (event.code === 'ALL_BUDGETS') {
        this.reviewFlow.flowBudgets.push(...this.budgets.filter(el => !el.code))
      } else {
        this.reviewFlow.flowBudgets.push(event)
      }
    },
    addBudget () {
      this.reviewFlow.flowBudgets.push(this.budgetToConfirm)
    },
    removeStep (index) {
      this.reviewFlow.steps.splice(index, 1)
    },
    async fetchBudgets () {
      const filters = {
        'status.code': 'ACTIVE',
        pagination: false
      }
      await this.$store.dispatch('BudgetsStore/setBudgetsFilters', filters)
    },
    async fetchUsers () {
      const filters = {
        'status.statusType.code': ['ACTIVE']
      }
      await this.$store.dispatch('UsersStore/setUsersFilters', { filters: filters, pagination: false })
    },
    addFlowStep () {
      this.reviewFlow.steps.push([{ name: '', reviewers: [] }])
    },
    async submitReviewFlow () {
      let reviewFlow = {
        name: this.reviewFlow.name,
        byDefault: this.reviewFlow.byDefault,
        flowBudgets: this.reviewFlow.flowBudgets.map(el => {
          return { budget: { id: el.id } }
        }),
        steps: this._generateStepData(this.reviewFlow.steps)

      }

      if (this.reviewFunnelId) {
        this.updateReviewFlow(reviewFlow)
      } else {
        this.createReviewFlow(reviewFlow)
      }
    },
    async createReviewFlow (reviewFlow) {
      try {
        await this.$store.dispatch('CompanyStore/TransactionFieldsStore/createReviewFlow', reviewFlow)
        this.closeModal()
      } catch (error) {
        this.$store.dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'company_create_review_flow_error' }, { root: true }
        )
      }
    },
    async updateReviewFlow (reviewFlow) {
      reviewFlow.id = this.reviewFunnelId
      try {
        await this.$store.dispatch('CompanyStore/TransactionFieldsStore/updateReviewFlow', reviewFlow)
        this.closeModal()
      } catch (error) {
        this.$store.dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'company_update_review_flow_error' }

        )
      }
    },

    _generateStepData (steps) {
      if (steps.length > 0) {
        let stepsData = []

        steps.forEach((el, index) => {
          let stepInfo = {
            position: index + 1,
            name: el.name,
            reviewerRoles: el.reviewers.filter(el => el.code === USER_ROLES.ROLE_ADMIN || el.code === USER_ROLES.ROLE_BOOKKEEPER).map(el => el.code),
            ownerCanReview: el.reviewers.some(el => el.code === USER_ROLES.FAKE_ROLE_BUDGET_OWNER),
            reviewerUserIds: el.reviewers.filter(el => !isNaN(el.id)).map(el => el.id)

          }
          if (el?.id) {
            stepInfo.id = el.id
          }
          stepsData.push(stepInfo)
        })
        return stepsData
      } else {
        return []
      }
    },
    _initialize () {
      this.reviewFlow.name = this.currentReviewFunnel.name
      this.reviewFlow.flowBudgets = [...this.currentReviewFunnel.flowBudgets.map(el => {
        return {
          id: el.budget.id,
          budget: { name: el.budget.name, id: el.budget.id }

        }
      })]
      this.reviewFlow.byDefault = this.currentReviewFunnel.byDefault
      this.reviewFlow.steps = this._initializeStepData()
    },
    _initializeStepData () {
      let steps = []
      this.currentReviewFunnel.steps.forEach(el => {
        let step = {}
        step.name = el.name
        step.reviewers = this._initializeReviewersData(el)
        if (el?.id) {
          step.id = el.id
        }
        steps.push(step)
      })
      return steps
    },
    _initializeReviewersData (reviewer) {
      const { reviewerRoles, stepUsers, ownerCanReview } = reviewer
      let reviewers = []
      if (reviewerRoles.some(el => el === USER_ROLES.ROLE_ADMIN)) {
        const fakeAdmin = this.reviewersOptions.find(el => el.code === USER_ROLES.ROLE_ADMIN)
        if (fakeAdmin.id) reviewers.push(fakeAdmin)
      }
      if (reviewerRoles.some(el => el === USER_ROLES.ROLE_BOOKKEEPER)) {
        const fakeBookkeeper = this.reviewersOptions.find(el => el.code === USER_ROLES.ROLE_BOOKKEEPER)
        if (fakeBookkeeper.id) reviewers.push(fakeBookkeeper)
      }
      if (ownerCanReview) {
        const fakeBudgetOwnerUser = this.reviewersOptions.find(el => el.code === USER_ROLES.FAKE_ROLE_BUDGET_OWNER)
        if (fakeBudgetOwnerUser) reviewers.push(fakeBudgetOwnerUser)
      }
      if (stepUsers.length > 0) {
        reviewers.push(...stepUsers.map(el => { return { id: el.id, firstName: el.firstName, lastName: el.lastName } }))
      }
      return reviewers
    }

  },
  validations: {
    reviewFlow: {
      name: { required },
      flowBudgets: { required, minLength: minLength(1) },
      steps: {
        required,
        minLength: minLength(1),
        $each: {
          name: { required },
          reviewers: { required }
        }

      }
    }
  },
  created () {
    this.fetchBudgets()
    this.fetchUsers()
    if (this.currentReviewFunnel) {
      this._initialize()
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  },
  watch: {
    reviewFunnelId: function (newV, oldV) {
      if (newV > 0) {
        this._initialize()
      }
    }
  }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.Fuell-Dragabble--column-content {
  &.left {
    max-width: 220px;
  }
}
.Fuell-Text--small {
  font-size: 13px;
  font-weight: 400;
}
.section-header {
  font-weight: 500;
  font-size: 15px;
  margin-top: 32px;
}

.label-hint {
  font-size: 12px;
  color: var(--text-body);
  margin-left: 5px;
}

.Fuell-Export--checkbox {
  input {
    min-height: auto;
    margin-right: 8px;
  }
}
.Fuell-Export--file-format {
  margin-top: 22px;
}
.form--label {
  min-height: 11px;
}
.input-step {
  min-height: 44px;
  height: 100%;
  background-color: var(--fill-text-area);
  padding: 10px 12px;
  &--error {
    border: 2px solid var(--semantic-negative-main);
    border-radius: 4px;
  }
}
.d-flex {
  margin-right: 4px;
}
.ModalBox {
  width: 656px;
  overflow: initial;
}
.multiselect--error {
  border: 2px solid red;
  border-radius: 6px;
}
.Fuell-Button {
  display: block;
  margin-top: 9px;
  text-align: center;
  font-size: 15px;
  line-height: 24px;
  &.Fuell-Button--add-column {
    background-color: var(--blue-action-1-special-active);
    color: var(--text-link);
    &:hover {
      color: var(--text-button);
      background-color: var(--blue-action-1-special-hover);
    }
  }
}
.close-container {
  display: flex;
  width: 8px;
  height: 8px;
  margin-left: 10px;
  margin-top: 20px;
  .icon-close {
    width: 8px;
    height: 8px;
  }
}
</style>
<style  lang="scss">
#funnel-aproval-flow-form .multiselect-tags .multiselect__tag {
  span {
    display: block;
    max-width: 140px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.role-delimiter {
  border-bottom: 1px solid var(--fill-border);
  position: absolute;
  height: 1px;
  width: calc(100% + 23px);
  top: 28px;
  left: -11px;
}
</style>
